import { resolvePayload } from "./const.routes";
import { parseError } from "../types/Error/Errors.ts";
import { err } from "../types/Result.ts";

export async function fetchHandler<T>(fetch: Promise<Response>) {
  try {
    const auth_response = await fetch;
    return await resolvePayload<T>(auth_response);
  } catch (error) {
    console.error(error);
    return err(parseError(error));
  }
}
